import { Container, Stack } from "@mui/material";
import React, { FC, useCallback, useMemo } from "react";
import { LoginComponentProps, LoginForm } from "shared-ts-ui-identity";
import { NavigationLessAppPage } from "shared-ts-ui-app-boot";
import { useAppInfo } from "shared-ts-app-info";
import { useLanguage } from "shared-ts-language";
import { ResponsiveMyChimneyLogo } from "firefly-my-chimney-ts-shared";
import { useTranslation } from "react-i18next";
import { useAppTheme } from "shared-ts-ui-app-theme-provider";
import { useSxMergeStrict } from "shared-ts-mui";
import { DeliveredByAirmont } from "firefly-my-chimney-ts-pages";

export const LoginPage: FC<LoginComponentProps> = (props) => {
  const { onRegisterNewUser } = props;
  const { t } = useTranslation("my-chimney-ts-translations");
  const appInfo = useAppInfo();
  const { themeName, setTheme } = useAppTheme();
  const { language, setLanguage } = useLanguage();

  const username = useMemo(
    () => new URLSearchParams(window.location.search).get("username"),
    []
  );

  const handleRegisterNewUser = useCallback(() => {
    onRegisterNewUser();
  }, [onRegisterNewUser]);

  const sx = useSxMergeStrict(() => [props.sx, {
    pt: 2,
    pb: 2,
  }],[props.sx]);
  return (
    <NavigationLessAppPage
      appName={t(appInfo.name as any)}
      appIcon={<ResponsiveMyChimneyLogo />}
      language={language}
      onLanguageChange={setLanguage}
      themeName={themeName}
      onThemeChange={setTheme as React.Dispatch<React.SetStateAction<string>>}
      sx={sx}
    >
      <Container
        maxWidth={"xs"}
        style={{
          flexGrow: 1,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Stack
          className={"AppLogin"}
          direction={"column"}
          useFlexGap
          gap={2}
          sx={{
            flexGrow: 1,
            minHeight: 0,
            justifyContent: "space-between",
          }}
        >
          <LoginForm
            {...props}
            onRegisterNewUser={handleRegisterNewUser}
            username={username}
          />
          <DeliveredByAirmont />
        </Stack>
      </Container>
    </NavigationLessAppPage>
  );
};
